import React from 'react'
import PropTypes from 'prop-types'

// Models
import Payment from 'models/Payment'

// Components
import Text from 'ui/Text'

export default function ColumnStatus({ row }) {
  return <Text color={row.statusColor}>• {row.status}</Text>
}

ColumnStatus.propTypes = {
  row: PropTypes.instanceOf(Payment),
}

ColumnStatus.defaultProps = {
  row: new Payment(),
}
